import React from 'react';
import {
  PRIORITY_ORDER, PRIORITY_LABEL, PRIORITY_SHORT_LABEL, PRIORITY_COLOR, PRIORITY_HELP,
  type BrokerPriorityCounts,
} from './brokerViewTokens';

/**
 * Compact stacked severity bar + legend — the shared per-card urgency signal.
 * Used by all three slice cards (seller / buyer / cluster) so the tabs look
 * identical: each renders the same colored urgency mix from its per-tier counts.
 */
export const SeverityBar: React.FC<{ counts: BrokerPriorityCounts; total: number }> = ({ counts, total }) => (
  <>
    <div className="bv-sev-bar" aria-hidden="true">
      {total > 0
        ? PRIORITY_ORDER.map((k) => {
            const c = counts?.[k] || 0;
            if (c === 0) return null;
            return (
              <span
                key={k}
                className="bv-sev-seg"
                style={{ width: `${(c / total) * 100}%`, background: PRIORITY_COLOR[k].pin }}
                title={`${c} ${PRIORITY_LABEL[k]} — ${PRIORITY_HELP[k]}`}
              />
            );
          })
        : <span className="bv-sev-seg bv-sev-seg-empty" style={{ width: '100%' }} />}
    </div>
    <div className="bv-sev-legend">
      {PRIORITY_ORDER.map((k) => {
        const c = counts?.[k] || 0;
        return (
          <span key={k} className={`bv-sev-item ${c === 0 ? 'zero' : ''}`} title={PRIORITY_HELP[k]}>
            <span className="bv-sev-dot" style={{ background: PRIORITY_COLOR[k].pin }} />
            <span className="bv-sev-count">{c}</span>
            <span className="bv-sev-name">{PRIORITY_SHORT_LABEL[k]}</span>
          </span>
        );
      })}
    </div>
  </>
);
